import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';
import { componentColors } from '../../../theme';
import { CardBtn } from '../../../components/base-components/base-componets';

export const AllModesContainer = styled(Box)`
  padding-bottom: 16px;
`;

export const AllModesTextContainer = styled(Box)`
  padding: 16px;
`;

export const ModesGridContainer = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;
  justify-items: center;
  justify-content: space-around;
  padding-bottom: 16px;
`;

interface ModeContainerBtnProps {
  isSelected: boolean;
}

export const ModeContainerBtn = styled(CardBtn, {
  shouldForwardProp: (prop) => prop !== "isSelected",
}) <ModeContainerBtnProps>`
  ${({ isSelected }) =>
    isSelected &&
    `
    border-color: ${componentColors.selectedItem};
    `
  }
`;

interface ModeContainerProps {
  modeColor: string;
}

export const ModeContainer = styled(ModeContainerBtn, {
  shouldForwardProp: (prop) => prop !== "modeColor",
}) <ModeContainerProps>`
  position: relative;
  width: 140px;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ modeColor }) => modeColor};
`;

export const ImageModeContainer = styled(Box) <React.ImgHTMLAttributes<HTMLImageElement>>`
  max-width: 70%;
  max-height: 70%;
  padding-bottom: 8px;
  object-fit: contain;
`;

export const ModeName = styled(Typography)`
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1em;
  text-shadow: 2px 2px black;
  text-align: center;
  white-space: nowrap;
  
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 16px;
  line-height: 20px;
  padding-left: 8px;
  padding-right: 8px;
`;

